export const LINE_MESSAGE_PLACEHOLDERS = [
  {
    token: '{เลขที่เคลม}',
    field: 'claimCode',
    label: 'เลขที่เคลม',
    description: 'เลขที่เคลม',
    example: 'CAMB000000001',
  },
  {
    token: '{ชื่อลูกค้า}',
    field: 'fullName',
    label: 'ชื่อลูกค้า',
    description: 'ชื่อ-นามสกุลลูกค้า',
    example: 'นาย ABC DDF',
  },
  {
    token: '{ชื่อสินค้า}',
    field: 'productName',
    label: 'ชื่อสินค้า',
    description: 'ชื่อสินค้าที่เคลม',
    example: 'iPhone',
  },
  {
    token: '{ยี่ห้อมือถือ}',
    field: 'mobileBrandName',
    label: 'ยี่ห้อมือถือ',
    description: 'ยี่ห้อมือถือ',
    example: 'Apple',
  },
  {
    token: '{รุ่นมือถือ}',
    field: 'mobileModelName',
    label: 'รุ่นมือถือ',
    description: 'รุ่นมือถือ',
    example: 'iPhone 17 Pro Max',
  },
];

export const renderClaimMessage = (template, record) => {
  const source = record || {};
  let text = template || '';
  LINE_MESSAGE_PLACEHOLDERS.forEach((placeholder) => {
    const raw = source[placeholder.field];
    const value = raw === undefined || raw === null ? '' : String(raw).trim();
    text = text.split(placeholder.token).join(value);
  });
  return text;
};

export const LINE_MESSAGE_SAMPLE_RECORD = LINE_MESSAGE_PLACEHOLDERS.reduce(
  (sample, placeholder) => {
    sample[placeholder.field] = placeholder.example;
    return sample;
  },
  {},
);
